export const USD = (amt: number | bigint | string | undefined) => {
  let val;
  if (!amt) {
    val = 0;
  } else if (typeof amt === 'string') {
    val = parseFloat(amt);
  } else {
    val = amt;
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(val);
};

export type ShortenCurrencyOptions = {
  shortenThousands?: boolean;
  hideZeroDecimals?: boolean;
};

export const shortenCurrency = (val: number | bigint | string | undefined, opts?: ShortenCurrencyOptions): string => {
  const { shortenThousands = false, hideZeroDecimals = false } = opts ?? {};

  let num: number;
  if (!val) {
    num = 0;
  } else if (typeof val === 'string') {
    num = parseFloat(val);
  } else {
    num = Number(val);
  }

  let suffix = '';

  if (num >= 1_000_000_000) {
    num = num / 1_000_000_000;
    suffix = 'B';
    // output = `${USD(num / 1_000_000_000)}B`;
  } else if (num >= 1_000_000) {
    num = num / 1_000_000;
    suffix = 'M';
    // output = `${USD(num / 1_000_000)}M`;
  } else if (shortenThousands && num >= 1_000) {
    num = num / 1_000;
    suffix = 'K';
    // output = `${USD(num / 1_000)}K`;
  }
  //  else {
  //   output = USD(num);
  // }

  let output = USD(num);

  if (hideZeroDecimals) {
    const o = output.split('.');
    if (o[1] === '00') output = o[0];
  }

  return `${output}${suffix}`;
};

/** Formats a number as a USD currency string. decimals=true forces 2 decimals; decimals=false omits them. */
export const formatCurrency = (n: number, decimals = true): string => {
  if (isNaN(n)) return '';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals ? 2 : 0,
    maximumFractionDigits: decimals ? 2 : 0,
  }).format(n);
};

/** Parses a (possibly formatted) string into a number, stripping anything that isn't a digit or dot. */
export const parseCurrency = (s: string): number => {
  return parseFloat(s.replace(/[^0-9.]/g, ''));
};

/** Strips non-numeric chars, keeping only the first dot so "1.2.3" -> "1.23". */
export const sanitizeNumeric = (s: string): string => {
  const cleaned = s.replace(/[^0-9.]/g, '');
  const dot = cleaned.indexOf('.');
  if (dot === -1) return cleaned;
  return cleaned.slice(0, dot + 1) + cleaned.slice(dot + 1).replace(/\./g, '');
};

/** Counts significant chars ([0-9.]) in s — commas/$ are ignored for caret mapping. */
export const countSig = (s: string): number => (s.match(/[0-9.]/g) || []).length;

/** Index in `s` after the Nth significant char (used to restore caret across comma/$ insertions/removals). */
export const indexOfSig = (s: string, n: number): number => {
  let count = 0;
  for (let i = 0; i < s.length; i++) {
    if (/[0-9.]/.test(s[i])) {
      count++;
      if (count === n) return i + 1;
    }
  }
  return s.length;
};
